import React from 'react';
import { Button } from '@components/ui/button';
import { GraduationCap } from 'lucide-react';

const WelcomeStep = ({ onNext }) => {
  return (
    <div className="text-center space-y-8 animate-fade-in">
      <div className="space-y-4">
        <div className="flex justify-center">
          <div className="p-4 rounded-full bg-primary/10">
            <GraduationCap className="w-16 h-16 text-primary" />
          </div>
        </div>

        <h1 className="text-4xl font-bold text-foreground">Welcome to Opennote</h1>

        <div className="space-y-4 max-w-2xl mx-auto">
          <p className="text-lg text-muted-foreground">
            Your personal AI learning companion for any subject you want to master.
          </p>

          <p className="text-muted-foreground">
            Let's personalize your learning experience in just a few simple steps.
          </p>
        </div>
      </div>

      <div className="pt-8">
        <Button onClick={() => onNext()} size="lg" className="px-8 py-6 text-lg font-medium">
          Get Started
        </Button>
      </div>
    </div>
  );
};

export default WelcomeStep;
